import React from 'react'
import { useHeapEvents } from '@toasttab/shared/src/hooks/useHeapEvents'

const PageElement = ({ children }: any) => {
  useHeapEvents('isCustomer', 'isCustomer')

  return <>{children}</>
}

export default PageElement
